"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SipMediaApplicationEndpointFilterSensitiveLog = exports.CreateProxySessionResponseFilterSensitiveLog = exports.ProxySessionFilterSensitiveLog = exports.ParticipantFilterSensitiveLog = exports.CreateProxySessionRequestFilterSensitiveLog = exports.GeoMatchParamsFilterSensitiveLog = exports.CreatePhoneNumberOrderResponseFilterSensitiveLog = exports.PhoneNumberOrderFilterSensitiveLog = exports.OrderedPhoneNumberFilterSensitiveLog = exports.CreatePhoneNumberOrderRequestFilterSensitiveLog = exports.CandidateAddressFilterSensitiveLog = exports.BatchUpdatePhoneNumberResponseFilterSensitiveLog = exports.BatchUpdatePhoneNumberRequestFilterSensitiveLog = exports.UpdatePhoneNumberRequestItemFilterSensitiveLog = exports.BatchDeletePhoneNumberResponseFilterSensitiveLog = exports.BatchDeletePhoneNumberRequestFilterSensitiveLog = exports.AssociatePhoneNumbersWithVoiceConnectorGroupResponseFilterSensitiveLog = exports.AssociatePhoneNumbersWithVoiceConnectorGroupRequestFilterSensitiveLog = exports.AssociatePhoneNumbersWithVoiceConnectorResponseFilterSensitiveLog = exports.PhoneNumberErrorFilterSensitiveLog = exports.AssociatePhoneNumbersWithVoiceConnectorRequestFilterSensitiveLog = exports.AddressFilterSensitiveLog = exports.NotificationTarget = exports.OriginationRouteProtocol = exports.PhoneNumberType = exports.PhoneNumberStatus = exports.PhoneNumberAssociationName = exports.VoiceConnectorAwsRegion = exports.SipRuleTriggerType = exports.ConflictException = exports.ProxySessionStatus = exports.NumberSelectionBehavior = exports.GeoMatchLevel = exports.ResourceLimitExceededException = exports.PhoneNumberOrderStatus = exports.PhoneNumberOrderType = exports.OrderedPhoneNumberStatus = exports.Capability = exports.CallingNameStatus = exports.PhoneNumberProductType = exports.UnauthorizedClientException = exports.ThrottledClientException = exports.ServiceUnavailableException = exports.ServiceFailureException = exports.NotFoundException = exports.ForbiddenException = exports.BadRequestException = exports.AlexaSkillStatus = exports.AccessDeniedException = exports.ErrorCode = void 0;
exports.GetSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = exports.SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog = exports.GetSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = exports.GetSipMediaApplicationResponseFilterSensitiveLog = exports.GetSipMediaApplicationRequestFilterSensitiveLog = exports.GetProxySessionResponseFilterSensitiveLog = exports.GetProxySessionRequestFilterSensitiveLog = exports.GetPhoneNumberSettingsResponseFilterSensitiveLog = exports.GetPhoneNumberOrderResponseFilterSensitiveLog = exports.GetPhoneNumberOrderRequestFilterSensitiveLog = exports.GetPhoneNumberResponseFilterSensitiveLog = exports.PhoneNumberFilterSensitiveLog = exports.PhoneNumberCapabilitiesFilterSensitiveLog = exports.PhoneNumberAssociationFilterSensitiveLog = exports.GetPhoneNumberRequestFilterSensitiveLog = exports.GetGlobalSettingsResponseFilterSensitiveLog = exports.VoiceConnectorSettingsFilterSensitiveLog = exports.DisassociatePhoneNumbersFromVoiceConnectorGroupResponseFilterSensitiveLog = exports.DisassociatePhoneNumbersFromVoiceConnectorGroupRequestFilterSensitiveLog = exports.DisassociatePhoneNumbersFromVoiceConnectorResponseFilterSensitiveLog = exports.DisassociatePhoneNumbersFromVoiceConnectorRequestFilterSensitiveLog = exports.DeleteVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = exports.DeleteVoiceConnectorTerminationRequestFilterSensitiveLog = exports.DeleteVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = exports.DeleteVoiceConnectorProxyRequestFilterSensitiveLog = exports.DeleteVoiceConnectorOriginationRequestFilterSensitiveLog = exports.DeleteVoiceConnectorGroupRequestFilterSensitiveLog = exports.DeleteVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = exports.DeleteVoiceConnectorRequestFilterSensitiveLog = exports.DeleteSipRuleRequestFilterSensitiveLog = exports.DeleteSipMediaApplicationRequestFilterSensitiveLog = exports.DeleteProxySessionRequestFilterSensitiveLog = exports.DeletePhoneNumberRequestFilterSensitiveLog = exports.CreateVoiceConnectorGroupResponseFilterSensitiveLog = exports.VoiceConnectorGroupFilterSensitiveLog = exports.CreateVoiceConnectorGroupRequestFilterSensitiveLog = exports.VoiceConnectorItemFilterSensitiveLog = exports.CreateVoiceConnectorResponseFilterSensitiveLog = exports.VoiceConnectorFilterSensitiveLog = exports.CreateVoiceConnectorRequestFilterSensitiveLog = exports.CreateSipRuleResponseFilterSensitiveLog = exports.SipRuleFilterSensitiveLog = exports.CreateSipRuleRequestFilterSensitiveLog = exports.SipRuleTargetApplicationFilterSensitiveLog = exports.CreateSipMediaApplicationCallResponseFilterSensitiveLog = exports.SipMediaApplicationCallFilterSensitiveLog = exports.CreateSipMediaApplicationCallRequestFilterSensitiveLog = exports.CreateSipMediaApplicationResponseFilterSensitiveLog = exports.SipMediaApplicationFilterSensitiveLog = exports.CreateSipMediaApplicationRequestFilterSensitiveLog = void 0;
exports.ListVoiceConnectorsRequestFilterSensitiveLog = exports.ListVoiceConnectorGroupsResponseFilterSensitiveLog = exports.ListVoiceConnectorGroupsRequestFilterSensitiveLog = exports.ListSupportedPhoneNumberCountriesResponseFilterSensitiveLog = exports.PhoneNumberCountryFilterSensitiveLog = exports.ListSupportedPhoneNumberCountriesRequestFilterSensitiveLog = exports.ListSipRulesResponseFilterSensitiveLog = exports.ListSipRulesRequestFilterSensitiveLog = exports.ListSipMediaApplicationsResponseFilterSensitiveLog = exports.ListSipMediaApplicationsRequestFilterSensitiveLog = exports.ListProxySessionsResponseFilterSensitiveLog = exports.ListProxySessionsRequestFilterSensitiveLog = exports.ListPhoneNumbersResponseFilterSensitiveLog = exports.ListPhoneNumbersRequestFilterSensitiveLog = exports.ListPhoneNumberOrdersResponseFilterSensitiveLog = exports.ListPhoneNumberOrdersRequestFilterSensitiveLog = exports.ListAvailableVoiceConnectorRegionsResponseFilterSensitiveLog = exports.GetVoiceConnectorTerminationHealthResponseFilterSensitiveLog = exports.TerminationHealthFilterSensitiveLog = exports.GetVoiceConnectorTerminationHealthRequestFilterSensitiveLog = exports.GetVoiceConnectorTerminationResponseFilterSensitiveLog = exports.TerminationFilterSensitiveLog = exports.GetVoiceConnectorTerminationRequestFilterSensitiveLog = exports.GetVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = exports.StreamingConfigurationFilterSensitiveLog = exports.StreamingNotificationTargetFilterSensitiveLog = exports.GetVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = exports.GetVoiceConnectorProxyResponseFilterSensitiveLog = exports.ProxyFilterSensitiveLog = exports.GetVoiceConnectorProxyRequestFilterSensitiveLog = exports.GetVoiceConnectorOriginationResponseFilterSensitiveLog = exports.OriginationFilterSensitiveLog = exports.OriginationRouteFilterSensitiveLog = exports.GetVoiceConnectorOriginationRequestFilterSensitiveLog = exports.GetVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = exports.LoggingConfigurationFilterSensitiveLog = exports.GetVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = exports.GetVoiceConnectorGroupResponseFilterSensitiveLog = exports.GetVoiceConnectorGroupRequestFilterSensitiveLog = exports.GetVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = exports.EmergencyCallingConfigurationFilterSensitiveLog = exports.DNISEmergencyCallingConfigurationFilterSensitiveLog = exports.GetVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = exports.GetVoiceConnectorResponseFilterSensitiveLog = exports.GetVoiceConnectorRequestFilterSensitiveLog = exports.GetSipRuleResponseFilterSensitiveLog = exports.GetSipRuleRequestFilterSensitiveLog = exports.GetSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = exports.SipMediaApplicationLoggingConfigurationFilterSensitiveLog = exports.GetSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = void 0;
exports.ValidateE911AddressResponseFilterSensitiveLog = exports.ValidateE911AddressRequestFilterSensitiveLog = exports.UpdateVoiceConnectorGroupResponseFilterSensitiveLog = exports.UpdateVoiceConnectorGroupRequestFilterSensitiveLog = exports.UpdateVoiceConnectorResponseFilterSensitiveLog = exports.UpdateVoiceConnectorRequestFilterSensitiveLog = exports.UpdateSipRuleResponseFilterSensitiveLog = exports.UpdateSipRuleRequestFilterSensitiveLog = exports.UpdateSipMediaApplicationCallResponseFilterSensitiveLog = exports.UpdateSipMediaApplicationCallRequestFilterSensitiveLog = exports.UpdateSipMediaApplicationResponseFilterSensitiveLog = exports.UpdateSipMediaApplicationRequestFilterSensitiveLog = exports.UpdateProxySessionResponseFilterSensitiveLog = exports.UpdateProxySessionRequestFilterSensitiveLog = exports.UpdatePhoneNumberSettingsRequestFilterSensitiveLog = exports.UpdatePhoneNumberResponseFilterSensitiveLog = exports.UpdatePhoneNumberRequestFilterSensitiveLog = exports.UpdateGlobalSettingsRequestFilterSensitiveLog = exports.SearchAvailablePhoneNumbersResponseFilterSensitiveLog = exports.SearchAvailablePhoneNumbersRequestFilterSensitiveLog = exports.RestorePhoneNumberResponseFilterSensitiveLog = exports.RestorePhoneNumberRequestFilterSensitiveLog = exports.PutVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = exports.CredentialFilterSensitiveLog = exports.PutVoiceConnectorTerminationResponseFilterSensitiveLog = exports.PutVoiceConnectorTerminationRequestFilterSensitiveLog = exports.PutVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = exports.PutVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = exports.PutVoiceConnectorProxyResponseFilterSensitiveLog = exports.PutVoiceConnectorProxyRequestFilterSensitiveLog = exports.PutVoiceConnectorOriginationResponseFilterSensitiveLog = exports.PutVoiceConnectorOriginationRequestFilterSensitiveLog = exports.PutVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = exports.PutVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = exports.PutVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = exports.PutVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = exports.PutSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = exports.PutSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = exports.PutSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = exports.PutSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = exports.ListVoiceConnectorTerminationCredentialsResponseFilterSensitiveLog = exports.ListVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = exports.ListVoiceConnectorsResponseFilterSensitiveLog = void 0;
const smithy_client_1 = require("@aws-sdk/smithy-client");
const ChimeSDKVoiceServiceException_1 = require("./ChimeSDKVoiceServiceException");
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["AccessDenied"] = "AccessDenied";
    ErrorCode["BadRequest"] = "BadRequest";
    ErrorCode["Conflict"] = "Conflict";
    ErrorCode["Forbidden"] = "Forbidden";
    ErrorCode["Gone"] = "Gone";
    ErrorCode["NotFound"] = "NotFound";
    ErrorCode["PhoneNumberAssociationsExist"] = "PhoneNumberAssociationsExist";
    ErrorCode["PreconditionFailed"] = "PreconditionFailed";
    ErrorCode["ResourceLimitExceeded"] = "ResourceLimitExceeded";
    ErrorCode["ServiceFailure"] = "ServiceFailure";
    ErrorCode["ServiceUnavailable"] = "ServiceUnavailable";
    ErrorCode["Throttled"] = "Throttled";
    ErrorCode["Throttling"] = "Throttling";
    ErrorCode["Unauthorized"] = "Unauthorized";
    ErrorCode["Unprocessable"] = "Unprocessable";
    ErrorCode["VoiceConnectorGroupAssociationsExist"] = "VoiceConnectorGroupAssociationsExist";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
class AccessDeniedException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        this.name = "AccessDeniedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.AccessDeniedException = AccessDeniedException;
var AlexaSkillStatus;
(function (AlexaSkillStatus) {
    AlexaSkillStatus["ACTIVE"] = "ACTIVE";
    AlexaSkillStatus["INACTIVE"] = "INACTIVE";
})(AlexaSkillStatus = exports.AlexaSkillStatus || (exports.AlexaSkillStatus = {}));
class BadRequestException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "BadRequestException",
            $fault: "client",
            ...opts,
        });
        this.name = "BadRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequestException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.BadRequestException = BadRequestException;
class ForbiddenException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ForbiddenException",
            $fault: "client",
            ...opts,
        });
        this.name = "ForbiddenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ForbiddenException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ForbiddenException = ForbiddenException;
class NotFoundException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "NotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "NotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotFoundException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.NotFoundException = NotFoundException;
class ServiceFailureException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ServiceFailureException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServiceFailureException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServiceFailureException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ServiceFailureException = ServiceFailureException;
class ServiceUnavailableException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServiceUnavailableException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServiceUnavailableException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ServiceUnavailableException = ServiceUnavailableException;
class ThrottledClientException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ThrottledClientException",
            $fault: "client",
            ...opts,
        });
        this.name = "ThrottledClientException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ThrottledClientException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ThrottledClientException = ThrottledClientException;
class UnauthorizedClientException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "UnauthorizedClientException",
            $fault: "client",
            ...opts,
        });
        this.name = "UnauthorizedClientException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnauthorizedClientException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.UnauthorizedClientException = UnauthorizedClientException;
var PhoneNumberProductType;
(function (PhoneNumberProductType) {
    PhoneNumberProductType["SipMediaApplicationDialIn"] = "SipMediaApplicationDialIn";
    PhoneNumberProductType["VoiceConnector"] = "VoiceConnector";
})(PhoneNumberProductType = exports.PhoneNumberProductType || (exports.PhoneNumberProductType = {}));
var CallingNameStatus;
(function (CallingNameStatus) {
    CallingNameStatus["Unassigned"] = "Unassigned";
    CallingNameStatus["UpdateFailed"] = "UpdateFailed";
    CallingNameStatus["UpdateInProgress"] = "UpdateInProgress";
    CallingNameStatus["UpdateSucceeded"] = "UpdateSucceeded";
})(CallingNameStatus = exports.CallingNameStatus || (exports.CallingNameStatus = {}));
var Capability;
(function (Capability) {
    Capability["SMS"] = "SMS";
    Capability["Voice"] = "Voice";
})(Capability = exports.Capability || (exports.Capability = {}));
var OrderedPhoneNumberStatus;
(function (OrderedPhoneNumberStatus) {
    OrderedPhoneNumberStatus["Acquired"] = "Acquired";
    OrderedPhoneNumberStatus["Failed"] = "Failed";
    OrderedPhoneNumberStatus["Processing"] = "Processing";
})(OrderedPhoneNumberStatus = exports.OrderedPhoneNumberStatus || (exports.OrderedPhoneNumberStatus = {}));
var PhoneNumberOrderType;
(function (PhoneNumberOrderType) {
    PhoneNumberOrderType["New"] = "New";
    PhoneNumberOrderType["Porting"] = "Porting";
})(PhoneNumberOrderType = exports.PhoneNumberOrderType || (exports.PhoneNumberOrderType = {}));
var PhoneNumberOrderStatus;
(function (PhoneNumberOrderStatus) {
    PhoneNumberOrderStatus["CancelRequested"] = "CancelRequested";
    PhoneNumberOrderStatus["Cancelled"] = "Cancelled";
    PhoneNumberOrderStatus["ChangeRequested"] = "ChangeRequested";
    PhoneNumberOrderStatus["Exception"] = "Exception";
    PhoneNumberOrderStatus["FOC"] = "FOC";
    PhoneNumberOrderStatus["Failed"] = "Failed";
    PhoneNumberOrderStatus["Partial"] = "Partial";
    PhoneNumberOrderStatus["PendingDocuments"] = "PendingDocuments";
    PhoneNumberOrderStatus["Processing"] = "Processing";
    PhoneNumberOrderStatus["Submitted"] = "Submitted";
    PhoneNumberOrderStatus["Successful"] = "Successful";
})(PhoneNumberOrderStatus = exports.PhoneNumberOrderStatus || (exports.PhoneNumberOrderStatus = {}));
class ResourceLimitExceededException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ResourceLimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceLimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceLimitExceededException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ResourceLimitExceededException = ResourceLimitExceededException;
var GeoMatchLevel;
(function (GeoMatchLevel) {
    GeoMatchLevel["AreaCode"] = "AreaCode";
    GeoMatchLevel["Country"] = "Country";
})(GeoMatchLevel = exports.GeoMatchLevel || (exports.GeoMatchLevel = {}));
var NumberSelectionBehavior;
(function (NumberSelectionBehavior) {
    NumberSelectionBehavior["AvoidSticky"] = "AvoidSticky";
    NumberSelectionBehavior["PreferSticky"] = "PreferSticky";
})(NumberSelectionBehavior = exports.NumberSelectionBehavior || (exports.NumberSelectionBehavior = {}));
var ProxySessionStatus;
(function (ProxySessionStatus) {
    ProxySessionStatus["Closed"] = "Closed";
    ProxySessionStatus["InProgress"] = "InProgress";
    ProxySessionStatus["Open"] = "Open";
})(ProxySessionStatus = exports.ProxySessionStatus || (exports.ProxySessionStatus = {}));
class ConflictException extends ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException {
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.Code = opts.Code;
        this.Message = opts.Message;
    }
}
exports.ConflictException = ConflictException;
var SipRuleTriggerType;
(function (SipRuleTriggerType) {
    SipRuleTriggerType["RequestUriHostname"] = "RequestUriHostname";
    SipRuleTriggerType["ToPhoneNumber"] = "ToPhoneNumber";
})(SipRuleTriggerType = exports.SipRuleTriggerType || (exports.SipRuleTriggerType = {}));
var VoiceConnectorAwsRegion;
(function (VoiceConnectorAwsRegion) {
    VoiceConnectorAwsRegion["AP_NORTHEAST_1"] = "ap-northeast-1";
    VoiceConnectorAwsRegion["AP_NORTHEAST_2"] = "ap-northeast-2";
    VoiceConnectorAwsRegion["AP_SOUTHEAST_1"] = "ap-southeast-1";
    VoiceConnectorAwsRegion["AP_SOUTHEAST_2"] = "ap-southeast-2";
    VoiceConnectorAwsRegion["CA_CENTRAL_1"] = "ca-central-1";
    VoiceConnectorAwsRegion["EU_CENTRAL_1"] = "eu-central-1";
    VoiceConnectorAwsRegion["EU_WEST_1"] = "eu-west-1";
    VoiceConnectorAwsRegion["EU_WEST_2"] = "eu-west-2";
    VoiceConnectorAwsRegion["US_EAST_1"] = "us-east-1";
    VoiceConnectorAwsRegion["US_WEST_2"] = "us-west-2";
})(VoiceConnectorAwsRegion = exports.VoiceConnectorAwsRegion || (exports.VoiceConnectorAwsRegion = {}));
var PhoneNumberAssociationName;
(function (PhoneNumberAssociationName) {
    PhoneNumberAssociationName["SipRuleId"] = "SipRuleId";
    PhoneNumberAssociationName["VoiceConnectorGroupId"] = "VoiceConnectorGroupId";
    PhoneNumberAssociationName["VoiceConnectorId"] = "VoiceConnectorId";
})(PhoneNumberAssociationName = exports.PhoneNumberAssociationName || (exports.PhoneNumberAssociationName = {}));
var PhoneNumberStatus;
(function (PhoneNumberStatus) {
    PhoneNumberStatus["AcquireFailed"] = "AcquireFailed";
    PhoneNumberStatus["AcquireInProgress"] = "AcquireInProgress";
    PhoneNumberStatus["Assigned"] = "Assigned";
    PhoneNumberStatus["Cancelled"] = "Cancelled";
    PhoneNumberStatus["DeleteFailed"] = "DeleteFailed";
    PhoneNumberStatus["DeleteInProgress"] = "DeleteInProgress";
    PhoneNumberStatus["PortinCancelRequested"] = "PortinCancelRequested";
    PhoneNumberStatus["PortinInProgress"] = "PortinInProgress";
    PhoneNumberStatus["ReleaseFailed"] = "ReleaseFailed";
    PhoneNumberStatus["ReleaseInProgress"] = "ReleaseInProgress";
    PhoneNumberStatus["Unassigned"] = "Unassigned";
})(PhoneNumberStatus = exports.PhoneNumberStatus || (exports.PhoneNumberStatus = {}));
var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["Local"] = "Local";
    PhoneNumberType["TollFree"] = "TollFree";
})(PhoneNumberType = exports.PhoneNumberType || (exports.PhoneNumberType = {}));
var OriginationRouteProtocol;
(function (OriginationRouteProtocol) {
    OriginationRouteProtocol["TCP"] = "TCP";
    OriginationRouteProtocol["UDP"] = "UDP";
})(OriginationRouteProtocol = exports.OriginationRouteProtocol || (exports.OriginationRouteProtocol = {}));
var NotificationTarget;
(function (NotificationTarget) {
    NotificationTarget["EventBridge"] = "EventBridge";
    NotificationTarget["SNS"] = "SNS";
    NotificationTarget["SQS"] = "SQS";
})(NotificationTarget = exports.NotificationTarget || (exports.NotificationTarget = {}));
const AddressFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.streetName && { streetName: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.streetSuffix && { streetSuffix: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.postDirectional && { postDirectional: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.preDirectional && { preDirectional: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.streetNumber && { streetNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.city && { city: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.state && { state: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.postalCode && { postalCode: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.postalCodePlus4 && { postalCodePlus4: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.country && { country: smithy_client_1.SENSITIVE_STRING }),
});
exports.AddressFilterSensitiveLog = AddressFilterSensitiveLog;
const AssociatePhoneNumbersWithVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.AssociatePhoneNumbersWithVoiceConnectorRequestFilterSensitiveLog = AssociatePhoneNumbersWithVoiceConnectorRequestFilterSensitiveLog;
const PhoneNumberErrorFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
});
exports.PhoneNumberErrorFilterSensitiveLog = PhoneNumberErrorFilterSensitiveLog;
const AssociatePhoneNumbersWithVoiceConnectorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.AssociatePhoneNumbersWithVoiceConnectorResponseFilterSensitiveLog = AssociatePhoneNumbersWithVoiceConnectorResponseFilterSensitiveLog;
const AssociatePhoneNumbersWithVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.AssociatePhoneNumbersWithVoiceConnectorGroupRequestFilterSensitiveLog = AssociatePhoneNumbersWithVoiceConnectorGroupRequestFilterSensitiveLog;
const AssociatePhoneNumbersWithVoiceConnectorGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.AssociatePhoneNumbersWithVoiceConnectorGroupResponseFilterSensitiveLog = AssociatePhoneNumbersWithVoiceConnectorGroupResponseFilterSensitiveLog;
const BatchDeletePhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.BatchDeletePhoneNumberRequestFilterSensitiveLog = BatchDeletePhoneNumberRequestFilterSensitiveLog;
const BatchDeletePhoneNumberResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.BatchDeletePhoneNumberResponseFilterSensitiveLog = BatchDeletePhoneNumberResponseFilterSensitiveLog;
const UpdatePhoneNumberRequestItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.CallingName && { CallingName: smithy_client_1.SENSITIVE_STRING }),
});
exports.UpdatePhoneNumberRequestItemFilterSensitiveLog = UpdatePhoneNumberRequestItemFilterSensitiveLog;
const BatchUpdatePhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UpdatePhoneNumberRequestItems && {
        UpdatePhoneNumberRequestItems: obj.UpdatePhoneNumberRequestItems.map((item) => (0, exports.UpdatePhoneNumberRequestItemFilterSensitiveLog)(item)),
    }),
});
exports.BatchUpdatePhoneNumberRequestFilterSensitiveLog = BatchUpdatePhoneNumberRequestFilterSensitiveLog;
const BatchUpdatePhoneNumberResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.BatchUpdatePhoneNumberResponseFilterSensitiveLog = BatchUpdatePhoneNumberResponseFilterSensitiveLog;
const CandidateAddressFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.streetInfo && { streetInfo: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.streetNumber && { streetNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.city && { city: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.state && { state: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.postalCode && { postalCode: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.postalCodePlus4 && { postalCodePlus4: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.country && { country: smithy_client_1.SENSITIVE_STRING }),
});
exports.CandidateAddressFilterSensitiveLog = CandidateAddressFilterSensitiveLog;
const CreatePhoneNumberOrderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.CreatePhoneNumberOrderRequestFilterSensitiveLog = CreatePhoneNumberOrderRequestFilterSensitiveLog;
const OrderedPhoneNumberFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumber && { E164PhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.OrderedPhoneNumberFilterSensitiveLog = OrderedPhoneNumberFilterSensitiveLog;
const PhoneNumberOrderFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.OrderedPhoneNumbers && {
        OrderedPhoneNumbers: obj.OrderedPhoneNumbers.map((item) => (0, exports.OrderedPhoneNumberFilterSensitiveLog)(item)),
    }),
});
exports.PhoneNumberOrderFilterSensitiveLog = PhoneNumberOrderFilterSensitiveLog;
const CreatePhoneNumberOrderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberOrder && { PhoneNumberOrder: (0, exports.PhoneNumberOrderFilterSensitiveLog)(obj.PhoneNumberOrder) }),
});
exports.CreatePhoneNumberOrderResponseFilterSensitiveLog = CreatePhoneNumberOrderResponseFilterSensitiveLog;
const GeoMatchParamsFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GeoMatchParamsFilterSensitiveLog = GeoMatchParamsFilterSensitiveLog;
const CreateProxySessionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ParticipantPhoneNumbers && { ParticipantPhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.Name && { Name: smithy_client_1.SENSITIVE_STRING }),
});
exports.CreateProxySessionRequestFilterSensitiveLog = CreateProxySessionRequestFilterSensitiveLog;
const ParticipantFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumber && { PhoneNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.ProxyPhoneNumber && { ProxyPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.ParticipantFilterSensitiveLog = ParticipantFilterSensitiveLog;
const ProxySessionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Participants && { Participants: obj.Participants.map((item) => (0, exports.ParticipantFilterSensitiveLog)(item)) }),
});
exports.ProxySessionFilterSensitiveLog = ProxySessionFilterSensitiveLog;
const CreateProxySessionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ProxySession && { ProxySession: (0, exports.ProxySessionFilterSensitiveLog)(obj.ProxySession) }),
});
exports.CreateProxySessionResponseFilterSensitiveLog = CreateProxySessionResponseFilterSensitiveLog;
const SipMediaApplicationEndpointFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.LambdaArn && { LambdaArn: smithy_client_1.SENSITIVE_STRING }),
});
exports.SipMediaApplicationEndpointFilterSensitiveLog = SipMediaApplicationEndpointFilterSensitiveLog;
const CreateSipMediaApplicationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Endpoints && { Endpoints: obj.Endpoints.map((item) => (0, exports.SipMediaApplicationEndpointFilterSensitiveLog)(item)) }),
});
exports.CreateSipMediaApplicationRequestFilterSensitiveLog = CreateSipMediaApplicationRequestFilterSensitiveLog;
const SipMediaApplicationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Endpoints && { Endpoints: obj.Endpoints.map((item) => (0, exports.SipMediaApplicationEndpointFilterSensitiveLog)(item)) }),
});
exports.SipMediaApplicationFilterSensitiveLog = SipMediaApplicationFilterSensitiveLog;
const CreateSipMediaApplicationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplication && {
        SipMediaApplication: (0, exports.SipMediaApplicationFilterSensitiveLog)(obj.SipMediaApplication),
    }),
});
exports.CreateSipMediaApplicationResponseFilterSensitiveLog = CreateSipMediaApplicationResponseFilterSensitiveLog;
const CreateSipMediaApplicationCallRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.FromPhoneNumber && { FromPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.ToPhoneNumber && { ToPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.SipHeaders && { SipHeaders: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.ArgumentsMap && { ArgumentsMap: smithy_client_1.SENSITIVE_STRING }),
});
exports.CreateSipMediaApplicationCallRequestFilterSensitiveLog = CreateSipMediaApplicationCallRequestFilterSensitiveLog;
const SipMediaApplicationCallFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SipMediaApplicationCallFilterSensitiveLog = SipMediaApplicationCallFilterSensitiveLog;
const CreateSipMediaApplicationCallResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateSipMediaApplicationCallResponseFilterSensitiveLog = CreateSipMediaApplicationCallResponseFilterSensitiveLog;
const SipRuleTargetApplicationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SipRuleTargetApplicationFilterSensitiveLog = SipRuleTargetApplicationFilterSensitiveLog;
const CreateSipRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateSipRuleRequestFilterSensitiveLog = CreateSipRuleRequestFilterSensitiveLog;
const SipRuleFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SipRuleFilterSensitiveLog = SipRuleFilterSensitiveLog;
const CreateSipRuleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateSipRuleResponseFilterSensitiveLog = CreateSipRuleResponseFilterSensitiveLog;
const CreateVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateVoiceConnectorRequestFilterSensitiveLog = CreateVoiceConnectorRequestFilterSensitiveLog;
const VoiceConnectorFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.VoiceConnectorFilterSensitiveLog = VoiceConnectorFilterSensitiveLog;
const CreateVoiceConnectorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateVoiceConnectorResponseFilterSensitiveLog = CreateVoiceConnectorResponseFilterSensitiveLog;
const VoiceConnectorItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.VoiceConnectorItemFilterSensitiveLog = VoiceConnectorItemFilterSensitiveLog;
const CreateVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateVoiceConnectorGroupRequestFilterSensitiveLog = CreateVoiceConnectorGroupRequestFilterSensitiveLog;
const VoiceConnectorGroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.VoiceConnectorGroupFilterSensitiveLog = VoiceConnectorGroupFilterSensitiveLog;
const CreateVoiceConnectorGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateVoiceConnectorGroupResponseFilterSensitiveLog = CreateVoiceConnectorGroupResponseFilterSensitiveLog;
const DeletePhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
});
exports.DeletePhoneNumberRequestFilterSensitiveLog = DeletePhoneNumberRequestFilterSensitiveLog;
const DeleteProxySessionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteProxySessionRequestFilterSensitiveLog = DeleteProxySessionRequestFilterSensitiveLog;
const DeleteSipMediaApplicationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteSipMediaApplicationRequestFilterSensitiveLog = DeleteSipMediaApplicationRequestFilterSensitiveLog;
const DeleteSipRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteSipRuleRequestFilterSensitiveLog = DeleteSipRuleRequestFilterSensitiveLog;
const DeleteVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorRequestFilterSensitiveLog = DeleteVoiceConnectorRequestFilterSensitiveLog;
const DeleteVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = DeleteVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog;
const DeleteVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorGroupRequestFilterSensitiveLog = DeleteVoiceConnectorGroupRequestFilterSensitiveLog;
const DeleteVoiceConnectorOriginationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorOriginationRequestFilterSensitiveLog = DeleteVoiceConnectorOriginationRequestFilterSensitiveLog;
const DeleteVoiceConnectorProxyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorProxyRequestFilterSensitiveLog = DeleteVoiceConnectorProxyRequestFilterSensitiveLog;
const DeleteVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = DeleteVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog;
const DeleteVoiceConnectorTerminationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteVoiceConnectorTerminationRequestFilterSensitiveLog = DeleteVoiceConnectorTerminationRequestFilterSensitiveLog;
const DeleteVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Usernames && { Usernames: smithy_client_1.SENSITIVE_STRING }),
});
exports.DeleteVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = DeleteVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog;
const DisassociatePhoneNumbersFromVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.DisassociatePhoneNumbersFromVoiceConnectorRequestFilterSensitiveLog = DisassociatePhoneNumbersFromVoiceConnectorRequestFilterSensitiveLog;
const DisassociatePhoneNumbersFromVoiceConnectorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.DisassociatePhoneNumbersFromVoiceConnectorResponseFilterSensitiveLog = DisassociatePhoneNumbersFromVoiceConnectorResponseFilterSensitiveLog;
const DisassociatePhoneNumbersFromVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.DisassociatePhoneNumbersFromVoiceConnectorGroupRequestFilterSensitiveLog = DisassociatePhoneNumbersFromVoiceConnectorGroupRequestFilterSensitiveLog;
const DisassociatePhoneNumbersFromVoiceConnectorGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberErrors && {
        PhoneNumberErrors: obj.PhoneNumberErrors.map((item) => (0, exports.PhoneNumberErrorFilterSensitiveLog)(item)),
    }),
});
exports.DisassociatePhoneNumbersFromVoiceConnectorGroupResponseFilterSensitiveLog = DisassociatePhoneNumbersFromVoiceConnectorGroupResponseFilterSensitiveLog;
const VoiceConnectorSettingsFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.VoiceConnectorSettingsFilterSensitiveLog = VoiceConnectorSettingsFilterSensitiveLog;
const GetGlobalSettingsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetGlobalSettingsResponseFilterSensitiveLog = GetGlobalSettingsResponseFilterSensitiveLog;
const GetPhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
});
exports.GetPhoneNumberRequestFilterSensitiveLog = GetPhoneNumberRequestFilterSensitiveLog;
const PhoneNumberAssociationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PhoneNumberAssociationFilterSensitiveLog = PhoneNumberAssociationFilterSensitiveLog;
const PhoneNumberCapabilitiesFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PhoneNumberCapabilitiesFilterSensitiveLog = PhoneNumberCapabilitiesFilterSensitiveLog;
const PhoneNumberFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.E164PhoneNumber && { E164PhoneNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.CallingName && { CallingName: smithy_client_1.SENSITIVE_STRING }),
});
exports.PhoneNumberFilterSensitiveLog = PhoneNumberFilterSensitiveLog;
const GetPhoneNumberResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumber && { PhoneNumber: (0, exports.PhoneNumberFilterSensitiveLog)(obj.PhoneNumber) }),
});
exports.GetPhoneNumberResponseFilterSensitiveLog = GetPhoneNumberResponseFilterSensitiveLog;
const GetPhoneNumberOrderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetPhoneNumberOrderRequestFilterSensitiveLog = GetPhoneNumberOrderRequestFilterSensitiveLog;
const GetPhoneNumberOrderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberOrder && { PhoneNumberOrder: (0, exports.PhoneNumberOrderFilterSensitiveLog)(obj.PhoneNumberOrder) }),
});
exports.GetPhoneNumberOrderResponseFilterSensitiveLog = GetPhoneNumberOrderResponseFilterSensitiveLog;
const GetPhoneNumberSettingsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CallingName && { CallingName: smithy_client_1.SENSITIVE_STRING }),
});
exports.GetPhoneNumberSettingsResponseFilterSensitiveLog = GetPhoneNumberSettingsResponseFilterSensitiveLog;
const GetProxySessionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetProxySessionRequestFilterSensitiveLog = GetProxySessionRequestFilterSensitiveLog;
const GetProxySessionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ProxySession && { ProxySession: (0, exports.ProxySessionFilterSensitiveLog)(obj.ProxySession) }),
});
exports.GetProxySessionResponseFilterSensitiveLog = GetProxySessionResponseFilterSensitiveLog;
const GetSipMediaApplicationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipMediaApplicationRequestFilterSensitiveLog = GetSipMediaApplicationRequestFilterSensitiveLog;
const GetSipMediaApplicationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplication && {
        SipMediaApplication: (0, exports.SipMediaApplicationFilterSensitiveLog)(obj.SipMediaApplication),
    }),
});
exports.GetSipMediaApplicationResponseFilterSensitiveLog = GetSipMediaApplicationResponseFilterSensitiveLog;
const GetSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = GetSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog;
const SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.AlexaSkillIds && { AlexaSkillIds: smithy_client_1.SENSITIVE_STRING }),
});
exports.SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog = SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog;
const GetSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplicationAlexaSkillConfiguration && {
        SipMediaApplicationAlexaSkillConfiguration: (0, exports.SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog)(obj.SipMediaApplicationAlexaSkillConfiguration),
    }),
});
exports.GetSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = GetSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog;
const GetSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = GetSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog;
const SipMediaApplicationLoggingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SipMediaApplicationLoggingConfigurationFilterSensitiveLog = SipMediaApplicationLoggingConfigurationFilterSensitiveLog;
const GetSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = GetSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog;
const GetSipRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipRuleRequestFilterSensitiveLog = GetSipRuleRequestFilterSensitiveLog;
const GetSipRuleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetSipRuleResponseFilterSensitiveLog = GetSipRuleResponseFilterSensitiveLog;
const GetVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorRequestFilterSensitiveLog = GetVoiceConnectorRequestFilterSensitiveLog;
const GetVoiceConnectorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorResponseFilterSensitiveLog = GetVoiceConnectorResponseFilterSensitiveLog;
const GetVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = GetVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog;
const DNISEmergencyCallingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.EmergencyPhoneNumber && { EmergencyPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.TestPhoneNumber && { TestPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.DNISEmergencyCallingConfigurationFilterSensitiveLog = DNISEmergencyCallingConfigurationFilterSensitiveLog;
const EmergencyCallingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DNIS && { DNIS: obj.DNIS.map((item) => (0, exports.DNISEmergencyCallingConfigurationFilterSensitiveLog)(item)) }),
});
exports.EmergencyCallingConfigurationFilterSensitiveLog = EmergencyCallingConfigurationFilterSensitiveLog;
const GetVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.EmergencyCallingConfiguration && {
        EmergencyCallingConfiguration: (0, exports.EmergencyCallingConfigurationFilterSensitiveLog)(obj.EmergencyCallingConfiguration),
    }),
});
exports.GetVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = GetVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog;
const GetVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorGroupRequestFilterSensitiveLog = GetVoiceConnectorGroupRequestFilterSensitiveLog;
const GetVoiceConnectorGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorGroupResponseFilterSensitiveLog = GetVoiceConnectorGroupResponseFilterSensitiveLog;
const GetVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = GetVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog;
const LoggingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.LoggingConfigurationFilterSensitiveLog = LoggingConfigurationFilterSensitiveLog;
const GetVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = GetVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog;
const GetVoiceConnectorOriginationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorOriginationRequestFilterSensitiveLog = GetVoiceConnectorOriginationRequestFilterSensitiveLog;
const OriginationRouteFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.OriginationRouteFilterSensitiveLog = OriginationRouteFilterSensitiveLog;
const OriginationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.OriginationFilterSensitiveLog = OriginationFilterSensitiveLog;
const GetVoiceConnectorOriginationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorOriginationResponseFilterSensitiveLog = GetVoiceConnectorOriginationResponseFilterSensitiveLog;
const GetVoiceConnectorProxyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorProxyRequestFilterSensitiveLog = GetVoiceConnectorProxyRequestFilterSensitiveLog;
const ProxyFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.FallBackPhoneNumber && { FallBackPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.ProxyFilterSensitiveLog = ProxyFilterSensitiveLog;
const GetVoiceConnectorProxyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Proxy && { Proxy: (0, exports.ProxyFilterSensitiveLog)(obj.Proxy) }),
});
exports.GetVoiceConnectorProxyResponseFilterSensitiveLog = GetVoiceConnectorProxyResponseFilterSensitiveLog;
const GetVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = GetVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog;
const StreamingNotificationTargetFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.StreamingNotificationTargetFilterSensitiveLog = StreamingNotificationTargetFilterSensitiveLog;
const StreamingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.StreamingConfigurationFilterSensitiveLog = StreamingConfigurationFilterSensitiveLog;
const GetVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = GetVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog;
const GetVoiceConnectorTerminationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorTerminationRequestFilterSensitiveLog = GetVoiceConnectorTerminationRequestFilterSensitiveLog;
const TerminationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.DefaultPhoneNumber && { DefaultPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.TerminationFilterSensitiveLog = TerminationFilterSensitiveLog;
const GetVoiceConnectorTerminationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Termination && { Termination: (0, exports.TerminationFilterSensitiveLog)(obj.Termination) }),
});
exports.GetVoiceConnectorTerminationResponseFilterSensitiveLog = GetVoiceConnectorTerminationResponseFilterSensitiveLog;
const GetVoiceConnectorTerminationHealthRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorTerminationHealthRequestFilterSensitiveLog = GetVoiceConnectorTerminationHealthRequestFilterSensitiveLog;
const TerminationHealthFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.TerminationHealthFilterSensitiveLog = TerminationHealthFilterSensitiveLog;
const GetVoiceConnectorTerminationHealthResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetVoiceConnectorTerminationHealthResponseFilterSensitiveLog = GetVoiceConnectorTerminationHealthResponseFilterSensitiveLog;
const ListAvailableVoiceConnectorRegionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListAvailableVoiceConnectorRegionsResponseFilterSensitiveLog = ListAvailableVoiceConnectorRegionsResponseFilterSensitiveLog;
const ListPhoneNumberOrdersRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListPhoneNumberOrdersRequestFilterSensitiveLog = ListPhoneNumberOrdersRequestFilterSensitiveLog;
const ListPhoneNumberOrdersResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListPhoneNumberOrdersResponseFilterSensitiveLog = ListPhoneNumberOrdersResponseFilterSensitiveLog;
const ListPhoneNumbersRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListPhoneNumbersRequestFilterSensitiveLog = ListPhoneNumbersRequestFilterSensitiveLog;
const ListPhoneNumbersResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumbers && { PhoneNumbers: obj.PhoneNumbers.map((item) => (0, exports.PhoneNumberFilterSensitiveLog)(item)) }),
});
exports.ListPhoneNumbersResponseFilterSensitiveLog = ListPhoneNumbersResponseFilterSensitiveLog;
const ListProxySessionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListProxySessionsRequestFilterSensitiveLog = ListProxySessionsRequestFilterSensitiveLog;
const ListProxySessionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListProxySessionsResponseFilterSensitiveLog = ListProxySessionsResponseFilterSensitiveLog;
const ListSipMediaApplicationsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSipMediaApplicationsRequestFilterSensitiveLog = ListSipMediaApplicationsRequestFilterSensitiveLog;
const ListSipMediaApplicationsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSipMediaApplicationsResponseFilterSensitiveLog = ListSipMediaApplicationsResponseFilterSensitiveLog;
const ListSipRulesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSipRulesRequestFilterSensitiveLog = ListSipRulesRequestFilterSensitiveLog;
const ListSipRulesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSipRulesResponseFilterSensitiveLog = ListSipRulesResponseFilterSensitiveLog;
const ListSupportedPhoneNumberCountriesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSupportedPhoneNumberCountriesRequestFilterSensitiveLog = ListSupportedPhoneNumberCountriesRequestFilterSensitiveLog;
const PhoneNumberCountryFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PhoneNumberCountryFilterSensitiveLog = PhoneNumberCountryFilterSensitiveLog;
const ListSupportedPhoneNumberCountriesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListSupportedPhoneNumberCountriesResponseFilterSensitiveLog = ListSupportedPhoneNumberCountriesResponseFilterSensitiveLog;
const ListVoiceConnectorGroupsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListVoiceConnectorGroupsRequestFilterSensitiveLog = ListVoiceConnectorGroupsRequestFilterSensitiveLog;
const ListVoiceConnectorGroupsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListVoiceConnectorGroupsResponseFilterSensitiveLog = ListVoiceConnectorGroupsResponseFilterSensitiveLog;
const ListVoiceConnectorsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListVoiceConnectorsRequestFilterSensitiveLog = ListVoiceConnectorsRequestFilterSensitiveLog;
const ListVoiceConnectorsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListVoiceConnectorsResponseFilterSensitiveLog = ListVoiceConnectorsResponseFilterSensitiveLog;
const ListVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = ListVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog;
const ListVoiceConnectorTerminationCredentialsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Usernames && { Usernames: smithy_client_1.SENSITIVE_STRING }),
});
exports.ListVoiceConnectorTerminationCredentialsResponseFilterSensitiveLog = ListVoiceConnectorTerminationCredentialsResponseFilterSensitiveLog;
const PutSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplicationAlexaSkillConfiguration && {
        SipMediaApplicationAlexaSkillConfiguration: (0, exports.SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog)(obj.SipMediaApplicationAlexaSkillConfiguration),
    }),
});
exports.PutSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog = PutSipMediaApplicationAlexaSkillConfigurationRequestFilterSensitiveLog;
const PutSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplicationAlexaSkillConfiguration && {
        SipMediaApplicationAlexaSkillConfiguration: (0, exports.SipMediaApplicationAlexaSkillConfigurationFilterSensitiveLog)(obj.SipMediaApplicationAlexaSkillConfiguration),
    }),
});
exports.PutSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog = PutSipMediaApplicationAlexaSkillConfigurationResponseFilterSensitiveLog;
const PutSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog = PutSipMediaApplicationLoggingConfigurationRequestFilterSensitiveLog;
const PutSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog = PutSipMediaApplicationLoggingConfigurationResponseFilterSensitiveLog;
const PutVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.EmergencyCallingConfiguration && {
        EmergencyCallingConfiguration: (0, exports.EmergencyCallingConfigurationFilterSensitiveLog)(obj.EmergencyCallingConfiguration),
    }),
});
exports.PutVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog = PutVoiceConnectorEmergencyCallingConfigurationRequestFilterSensitiveLog;
const PutVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.EmergencyCallingConfiguration && {
        EmergencyCallingConfiguration: (0, exports.EmergencyCallingConfigurationFilterSensitiveLog)(obj.EmergencyCallingConfiguration),
    }),
});
exports.PutVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog = PutVoiceConnectorEmergencyCallingConfigurationResponseFilterSensitiveLog;
const PutVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog = PutVoiceConnectorLoggingConfigurationRequestFilterSensitiveLog;
const PutVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog = PutVoiceConnectorLoggingConfigurationResponseFilterSensitiveLog;
const PutVoiceConnectorOriginationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorOriginationRequestFilterSensitiveLog = PutVoiceConnectorOriginationRequestFilterSensitiveLog;
const PutVoiceConnectorOriginationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorOriginationResponseFilterSensitiveLog = PutVoiceConnectorOriginationResponseFilterSensitiveLog;
const PutVoiceConnectorProxyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.FallBackPhoneNumber && { FallBackPhoneNumber: smithy_client_1.SENSITIVE_STRING }),
});
exports.PutVoiceConnectorProxyRequestFilterSensitiveLog = PutVoiceConnectorProxyRequestFilterSensitiveLog;
const PutVoiceConnectorProxyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Proxy && { Proxy: (0, exports.ProxyFilterSensitiveLog)(obj.Proxy) }),
});
exports.PutVoiceConnectorProxyResponseFilterSensitiveLog = PutVoiceConnectorProxyResponseFilterSensitiveLog;
const PutVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog = PutVoiceConnectorStreamingConfigurationRequestFilterSensitiveLog;
const PutVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog = PutVoiceConnectorStreamingConfigurationResponseFilterSensitiveLog;
const PutVoiceConnectorTerminationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Termination && { Termination: (0, exports.TerminationFilterSensitiveLog)(obj.Termination) }),
});
exports.PutVoiceConnectorTerminationRequestFilterSensitiveLog = PutVoiceConnectorTerminationRequestFilterSensitiveLog;
const PutVoiceConnectorTerminationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Termination && { Termination: (0, exports.TerminationFilterSensitiveLog)(obj.Termination) }),
});
exports.PutVoiceConnectorTerminationResponseFilterSensitiveLog = PutVoiceConnectorTerminationResponseFilterSensitiveLog;
const CredentialFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Username && { Username: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.Password && { Password: smithy_client_1.SENSITIVE_STRING }),
});
exports.CredentialFilterSensitiveLog = CredentialFilterSensitiveLog;
const PutVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Credentials && { Credentials: obj.Credentials.map((item) => (0, exports.CredentialFilterSensitiveLog)(item)) }),
});
exports.PutVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog = PutVoiceConnectorTerminationCredentialsRequestFilterSensitiveLog;
const RestorePhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
});
exports.RestorePhoneNumberRequestFilterSensitiveLog = RestorePhoneNumberRequestFilterSensitiveLog;
const RestorePhoneNumberResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumber && { PhoneNumber: (0, exports.PhoneNumberFilterSensitiveLog)(obj.PhoneNumber) }),
});
exports.RestorePhoneNumberResponseFilterSensitiveLog = RestorePhoneNumberResponseFilterSensitiveLog;
const SearchAvailablePhoneNumbersRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SearchAvailablePhoneNumbersRequestFilterSensitiveLog = SearchAvailablePhoneNumbersRequestFilterSensitiveLog;
const SearchAvailablePhoneNumbersResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.E164PhoneNumbers && { E164PhoneNumbers: smithy_client_1.SENSITIVE_STRING }),
});
exports.SearchAvailablePhoneNumbersResponseFilterSensitiveLog = SearchAvailablePhoneNumbersResponseFilterSensitiveLog;
const UpdateGlobalSettingsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateGlobalSettingsRequestFilterSensitiveLog = UpdateGlobalSettingsRequestFilterSensitiveLog;
const UpdatePhoneNumberRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumberId && { PhoneNumberId: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.CallingName && { CallingName: smithy_client_1.SENSITIVE_STRING }),
});
exports.UpdatePhoneNumberRequestFilterSensitiveLog = UpdatePhoneNumberRequestFilterSensitiveLog;
const UpdatePhoneNumberResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PhoneNumber && { PhoneNumber: (0, exports.PhoneNumberFilterSensitiveLog)(obj.PhoneNumber) }),
});
exports.UpdatePhoneNumberResponseFilterSensitiveLog = UpdatePhoneNumberResponseFilterSensitiveLog;
const UpdatePhoneNumberSettingsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.CallingName && { CallingName: smithy_client_1.SENSITIVE_STRING }),
});
exports.UpdatePhoneNumberSettingsRequestFilterSensitiveLog = UpdatePhoneNumberSettingsRequestFilterSensitiveLog;
const UpdateProxySessionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateProxySessionRequestFilterSensitiveLog = UpdateProxySessionRequestFilterSensitiveLog;
const UpdateProxySessionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ProxySession && { ProxySession: (0, exports.ProxySessionFilterSensitiveLog)(obj.ProxySession) }),
});
exports.UpdateProxySessionResponseFilterSensitiveLog = UpdateProxySessionResponseFilterSensitiveLog;
const UpdateSipMediaApplicationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Endpoints && { Endpoints: obj.Endpoints.map((item) => (0, exports.SipMediaApplicationEndpointFilterSensitiveLog)(item)) }),
});
exports.UpdateSipMediaApplicationRequestFilterSensitiveLog = UpdateSipMediaApplicationRequestFilterSensitiveLog;
const UpdateSipMediaApplicationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SipMediaApplication && {
        SipMediaApplication: (0, exports.SipMediaApplicationFilterSensitiveLog)(obj.SipMediaApplication),
    }),
});
exports.UpdateSipMediaApplicationResponseFilterSensitiveLog = UpdateSipMediaApplicationResponseFilterSensitiveLog;
const UpdateSipMediaApplicationCallRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Arguments && { Arguments: smithy_client_1.SENSITIVE_STRING }),
});
exports.UpdateSipMediaApplicationCallRequestFilterSensitiveLog = UpdateSipMediaApplicationCallRequestFilterSensitiveLog;
const UpdateSipMediaApplicationCallResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateSipMediaApplicationCallResponseFilterSensitiveLog = UpdateSipMediaApplicationCallResponseFilterSensitiveLog;
const UpdateSipRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateSipRuleRequestFilterSensitiveLog = UpdateSipRuleRequestFilterSensitiveLog;
const UpdateSipRuleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateSipRuleResponseFilterSensitiveLog = UpdateSipRuleResponseFilterSensitiveLog;
const UpdateVoiceConnectorRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateVoiceConnectorRequestFilterSensitiveLog = UpdateVoiceConnectorRequestFilterSensitiveLog;
const UpdateVoiceConnectorResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateVoiceConnectorResponseFilterSensitiveLog = UpdateVoiceConnectorResponseFilterSensitiveLog;
const UpdateVoiceConnectorGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateVoiceConnectorGroupRequestFilterSensitiveLog = UpdateVoiceConnectorGroupRequestFilterSensitiveLog;
const UpdateVoiceConnectorGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UpdateVoiceConnectorGroupResponseFilterSensitiveLog = UpdateVoiceConnectorGroupResponseFilterSensitiveLog;
const ValidateE911AddressRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.StreetNumber && { StreetNumber: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.StreetInfo && { StreetInfo: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.City && { City: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.State && { State: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.Country && { Country: smithy_client_1.SENSITIVE_STRING }),
    ...(obj.PostalCode && { PostalCode: smithy_client_1.SENSITIVE_STRING }),
});
exports.ValidateE911AddressRequestFilterSensitiveLog = ValidateE911AddressRequestFilterSensitiveLog;
const ValidateE911AddressResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Address && { Address: (0, exports.AddressFilterSensitiveLog)(obj.Address) }),
    ...(obj.CandidateAddressList && {
        CandidateAddressList: obj.CandidateAddressList.map((item) => (0, exports.CandidateAddressFilterSensitiveLog)(item)),
    }),
});
exports.ValidateE911AddressResponseFilterSensitiveLog = ValidateE911AddressResponseFilterSensitiveLog;
